import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'jquery-migrate';

export default $;
